import type { User, UserUpdate } from 'types/models/user';
import { patchRequest, postRequest } from 'utils/request';

export const rollAPIKey = (userId: string) => postRequest(`/users/${userId}/roll`);

export const updateUser = (userId: string, userUpdate: UserUpdate): Promise<User> =>
  patchRequest(`/users/${userId}`, userUpdate);
